import { graphql } from "react-relay";

export const CreateInstructionGenerationRequestMutation = graphql`
  mutation CreateInstructionGenerationRequestMutation(
    $input: CreateInstructionGenerationRequestInput!
  ) {
    createInstructionGenerationRequest(input: $input) {
      success
      error
      generationRequestId
    }
  }
`;
